import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Privacy Policy</h1>
      
      <div className="policy-content">
        <div style={{ marginBottom: '20px' }}>
          <p style={{ marginBottom: '10px' }}>Website: <a href="http://www.omegaopscyberdefence.com">www.omegaopscyberdefence.com</a></p>
          <p style={{ marginBottom: '10px' }}>Email: <a href="mailto:corporate@omegaopscyberdefence.com">corporate@omegaopscyberdefence.com</a></p>
          <p style={{ marginBottom: '20px' }}>Effective Date: March 19th, 2025</p>
          <hr style={{ margin: '30px 0', border: 'none', borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }} />
        </div>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>1. Overview</h2>
          <p>This Privacy Policy explains how we collect, use, and safeguard any information you may provide when visiting our corporate website. This policy does not apply to product usage (e.g., Omega Void&trade;) or any app-based activity.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>2. Information We Collect</h2>
          <p>We do not actively collect personal data on this corporate site. However, you may provide information voluntarily if you contact us via email or fill out a form.</p>
          <p style={{ marginTop: '10px', marginBottom: '10px' }}>We may passively collect limited non-personal information such as:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '10px' }}>
            <li style={{ marginBottom: '5px' }}>Browser type</li>
            <li style={{ marginBottom: '5px' }}>IP address</li>
            <li style={{ marginBottom: '5px' }}>Referral pages</li>
            <li style={{ marginBottom: '5px' }}>Time and date of visit</li>
            <li style={{ marginBottom: '5px' }}>Basic analytics via cookies</li>
          </ul>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>3. How We Use Information</h2>
          <p>Any information voluntarily provided will be used solely to:</p>
          <ul style={{ marginLeft: '20px', marginTop: '10px', marginBottom: '10px' }}>
            <li style={{ marginBottom: '5px' }}>Respond to inquiries</li>
            <li style={{ marginBottom: '5px' }}>Provide requested information about our projects</li>
            <li style={{ marginBottom: '5px' }}>Improve the website experience</li>
          </ul>
          <p style={{ marginTop: '10px' }}>We do <strong>not</strong> sell, rent, or share personal data with third parties.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>4. Cookies</h2>
          <p>We may use basic cookies or analytics tools to improve our site functionality and understand visitor behavior. You may disable cookies through your browser settings.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>5. Data Security</h2>
          <p>While no system is 100% secure, we implement appropriate technical measures to protect any information that is shared with us.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>6. Third-Party Services</h2>
          <p>Links on this site may lead to external sites (e.g., YouTube). We are not responsible for the privacy practices of these third parties.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>7. Children's Privacy</h2>
          <p>This website is not intended for children under the age of 13, and we do not knowingly collect data from them.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>8. Governing Law</h2>
          <p>This Privacy Policy shall be governed by the laws of Canada and the United States. Any disputes shall be resolved in the appropriate jurisdiction in the U.S.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>9. Updates to This Policy</h2>
          <p>We may update this Privacy Policy as needed. Changes will be posted on this page with a revised "Effective Date."</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>10. Contact</h2>
          <p>If you have any questions or concerns about this Privacy Policy, please reach out to:</p>
          <p style={{ marginTop: '10px' }}>
            <a href="mailto:corporate@omegaopscyberdefence.com">corporate@omegaopscyberdefence.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;